import PropTypes from 'prop-types';
import TextFormField from './IntegrationTextFormField';
import CheckboxFormField from './IntegrationCheckboxFormField';
import Row from './IntegrationFormRow';

_ExcelInvoiceIntegration.propTypes = {
  value: PropTypes.object,
  setValue: PropTypes.func
};

export default function _ExcelInvoiceIntegration({ value, setValue }) {
  return <>
    <Row>
      <TextFormField
        header={`Order Number Column`}
        value={value.orderNumberCol}
        onChange={(e) => setValue({ ...value, orderNumberCol: e.target.value })}
      />
      <TextFormField
        header={`Account ${value.accountIsPartOfFacilityName  ? "Regex" : "Column"}`}
        value={value.accountCol}
        onChange={(e) => setValue({ ...value, accountCol: e.target.value })}
      />
    </Row>
    <Row>
      <TextFormField
        header={`Facility Name Column`}
        value={value.facilityNameCol}
        onChange={(e) => setValue({ ...value, facilityNameCol: e.target.value })}
      />
      <TextFormField
        header={`Facility Address Column`}
        value={value.facilityAddressCol}
        onChange={(e) => setValue({ ...value, facilityAddressCol: e.target.value })}
      />
    </Row>
    <Row>
      <TextFormField
        header={`Invoice Number Column`}
        value={value.invoiceNumberCol}
        onChange={(e) => setValue({ ...value, invoiceNumberCol: e.target.value })}
      />
      <TextFormField
        header={`Invoice Date Column`}
        value={value.invoiceDateCol}
        onChange={(e) => setValue({ ...value, invoiceDateCol: e.target.value })}
      />
    </Row>
    <Row>
      <TextFormField
        header={"Vendor Item Id Column"}
        value={value.vendorItemIdCol}
        onChange={(e) => setValue({ ...value, vendorItemIdCol: e.target.value })}
      />
      <TextFormField
        header={"Description Column"}
        value={value.descriptionCol}
        onChange={(e) => setValue({ ...value, descriptionCol: e.target.value })}
      />
      <TextFormField
        header={"UOM Column"}
        value={value.uomCol}
        onChange={(e) => setValue({ ...value, uomCol: e.target.value })}
      />
    </Row>
    <Row>
      <TextFormField
        header={"Quantity Column"}
        value={value.qtyCol}
        onChange={(e) => setValue({ ...value, qtyCol: e.target.value })}
      />
      <TextFormField
        header={"Price Column"}
        value={value.priceCol}
        onChange={(e) => setValue({ ...value, priceCol: e.target.value })}
      />
      <TextFormField
        header={"Tax Column"}
        value={value.taxCol}
        onChange={(e) => setValue({ ...value, taxCol: e.target.value })}
      />
    </Row>
    <CheckboxFormField label={"Check For Imported Orders"}
      checked={value.canBeForImportedOrders ?? false}
      onChange={(e) => setValue({ ...value, canBeForImportedOrders: e.target.checked })}
    />
    <CheckboxFormField
      label={"Price Column Is Total"}
      checked={value.priceIsTotal ?? false}
      onChange={(e) => setValue({ ...value, priceIsTotal: e.target.checked })}
    />
    <CheckboxFormField
      label={"Account Is Part Of Facility Name"}
      checked={value.accountIsPartOfFacilityName ?? false}
      onChange={(e) => setValue({ ...value, accountIsPartOfFacilityName: e.target.checked })}
    />   
    <CheckboxFormField
      label={"Account Is Part Of File Name"}
      checked={value.accountIsPartOfFileName ?? false}
      onChange={(e) => setValue({ ...value, accountIsPartOfFileName: e.target.checked })}
    />       
  </>;
}
